import React from 'react'
import Header from './Header'
import Container from './Container'
import Button from './Button'
import Thingy from './Thingy'


const Hero = () => {
	return <div className="Hero">
		<Header></Header>
		<Container>
			<Thingy>
				<h1 className='BigTitle'>Alternative Tycoon</h1>
				<p className='BigText'> Симулятор IT-компании. Ваш проводник в мир финснсовой грамотности.</p>
			</Thingy>

			<Button link="./AlternativeTycoon.zip" download>Скачать!</Button>
		</Container>
	</div>
}

export default Hero